import { toPng } from "html-to-image";
import { forwardRef, useImperativeHandle, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import ScatterChart from "../components/chart/ScatterChart";
import { M3Surface } from "../components/m3";
import { GWP_LOG_AXIS } from "./gwpScatterAxes";

// Chart cards fill their grid cell; the chart draws its own title bar.
const CHART_SURFACE_STYLE = { height: "100%", overflow: "hidden" };

const NomarlizedGwpVsPercentageMciChart = forwardRef(({ topic = "Product", combined_data }, parentRef) => {
  const { t } = useTranslation();
  const ref = useRef();

  useImperativeHandle(parentRef, () => ({
    getScreenshot: async () => {
      if (ref.current) {
        return await toPng(ref.current, { cacheBust: true, backgroundColor: "#ffffff" });
      }
      return null;
    },
  }));

  const percentage_product_mci = useMemo(() => combined_data?.percentage_product_mci || 0, [combined_data?.percentage_product_mci]);
  const circularities = useMemo(() => combined_data?.combined_circularities || [], [combined_data?.combined_circularities]);

  const data = useMemo(() => {
    return circularities.map((row, index) => ({
      ...row,
      label: row?.description || `Point ${index + 1}`,
    }));
  }, [circularities]);

  const x = useMemo(() => ({ type: "number", dataKey: "percentage_mci", name: "Percent MCI", unit: "" }), []);
  const referenceLines = useMemo(
    () => [{ axis: "x", value: percentage_product_mci, label: `${t(topic + " MCI")} = ${(percentage_product_mci * 100).toFixed(1)}%`, dashed: true }],
    [percentage_product_mci, topic, t]
  );

  return (
    <M3Surface ref={ref} style={CHART_SURFACE_STYLE}>
      <ScatterChart
        x={x}
        y={GWP_LOG_AXIS}
        sizeKey={GWP_LOG_AXIS.dataKey}
        title={"GWP vs MCI Chart"}
        data={data}
        referenceLines={referenceLines}
      />
    </M3Surface>
  );
});

export default NomarlizedGwpVsPercentageMciChart;
